import { Article } from '@wix/ambassador-answers-search-proxy/types';
import { Category } from '@wix/answers-api';
import Head from 'next/head';
import React, { FunctionComponent } from 'react';

import { LOCALES, SEO } from '../../../constants';
import { shouldAddNoIndex } from '../../../utils/should-add-no-index';
import { stripHTML } from '../../../utils/text';
import { BasicSeoElements } from '../BasicSEO';
import { useBabelSeo } from '../useBabelSeo';

type ArticlePageProps = {
  article?: Article;
  categoriesTree?: Category[];
};

export const ArticlePageSEO: FunctionComponent<ArticlePageProps> = ({
  article,
  categoriesTree,
}) => {
  const resolveBabelSeo = useBabelSeo();
  const parseArticleDescription = (content?: string) => {
    if (!content) {
      return '';
    } else {
      const MAX_DESCRIPTION_LENGTH = 160;
      return stripHTML(content).trim().slice(0, MAX_DESCRIPTION_LENGTH);
    }
  };

  const description = parseArticleDescription(article?.content);

  const title = resolveBabelSeo('seo.article_page.title', {
    articleTitle: article?.title || '',
  });

  const alternateDefaultUrl = article?.translations?.find(
    (e) => e.locale === LOCALES.EN
  )?.url;

  const noIndex = shouldAddNoIndex(article, categoriesTree);
  const robots = {
    noArchive: false,
    noFollow: false,
    noIndex: noIndex ?? false,
  };

  return (
    <>
      <BasicSeoElements
        title={title}
        description={description}
        imageUrl={SEO.SOCIAL_IMAGE_URL}
        robots={robots}
      />
      <Head>
        {article?.translations?.map(({ url, locale: localeTr }) => (
          <link rel="alternate" hrefLang={localeTr} href={url} key={url} />
        ))}
        {alternateDefaultUrl && (
          <link
            rel="alternate"
            hrefLang="x-default"
            href={alternateDefaultUrl}
          />
        )}
      </Head>
    </>
  );
};
